import { AnalyticsInsightsCardController } from './analytics-insights-card.controller'

function analyticsInsightsCard () {
  return {
    restrict: 'E',
    scope: {
      card: '<',
      cardsLength: '<',
      locale: '<'
    },
    templateUrl: '/analytics/directives/analytics-insights-card/analytics-insights-card-directive.html?$$REVISION$$',
    controller: AnalyticsInsightsCardController
  }
}

export { analyticsInsightsCard }
